import { cloneElement, isValidElement } from "react";

export default function Panel({ children, as, className, ...props }) {
  const computedClassName = ["panel", ...className.split(" ")].join(" ").trim();
  return (
    (!!as &&
      isValidElement(as) &&
      cloneElement(
        as,
        { className: computedClassName, ...props },
        children,
      )) || (
      <div className={computedClassName} {...props}>
        {children}
      </div>
    )
  );
}

Panel.defaultProps = {
  className: "",
};
